import { WORD_STATUS } from '../dataManagement/Constants';
import { shuffleArray } from '../../../lib/utilityFunctions';
import SvgMap from '../assets/svgComponents/SvgMap';
import { getAwsAudio } from '../assets/audio/AudioMap';

export const makeShuffledArray = originalArray => {
  let shuffledArray = [...originalArray];
  let stillTheSame = true;
  do {
    shuffledArray = shuffleArray(shuffledArray);
    for (let i = 0; i < shuffledArray.length; i++) {
      if (shuffledArray[i] !== originalArray[i]) {
        stillTheSame = false;
        break;
      }
    }
  } while (stillTheSame);

  return shuffledArray;
};

export const parseContentIndexesToIllustrationFilename = (levelIndex, itemIndex, definitionIndex) =>
  SvgMap[parseContentIndexesToMapKey(levelIndex, itemIndex)][definitionIndex];

export const parseContentIndexesToAudioWordFilename = (levelIndex, itemIndex, definitionIndex) =>
  getAwsAudio()[parseContentIndexesToMapKey(levelIndex, itemIndex)][`word${definitionIndex + 1}`].file;

export const parseContentIndexesToAudioDirectionFilenames = (levelIndex, itemIndex) => {
  const { definition, from, to } = getAwsAudio()[parseContentIndexesToMapKey(levelIndex, itemIndex)];
  return [getAwsAudio().common.arrange_the_words.file, definition.file, from.file, to.file];
};

const parseContentIndexesToMapKey = (levelIndex, itemIndex) => `level${levelIndex + 1}item${itemIndex + 1}`;

let nextPositionMarkerKey = 0;
export const createPositionMarkers = wordsSet =>
  wordsSet.map((wordData, i) => ({
    id: i,
    position: null,
    key: nextPositionMarkerKey++,
  }));

// creates dragable data with specific ID and unique key
let nextDraggableKey = 0;
export const createDraggables = wordsSet =>
  wordsSet.map((wordData, i) => ({
    id: i,
    position: 0,
    order: i,
    wordData,
    withDescription: false,
    withIncorrectStyle: false,
    canSnap: true,
    status: WORD_STATUS.UNSELECTED,
    key: nextDraggableKey++,
  }));

// makes a special "shuffled" (hard coded) set for onboarding
export const makeOnBoardingSet = originalSet => {
  const onboardingSet = [...originalSet];
  const [, temp] = onboardingSet;
  onboardingSet[1] = onboardingSet[2];
  onboardingSet[2] = temp;
  return onboardingSet;
};
